import { render } from "./Corporate.vue?vue&type=template&id=42fb0eb0"
import script from "./Corporate.vue?vue&type=script&lang=js"
export * from "./Corporate.vue?vue&type=script&lang=js"

import "./Corporate.vue?vue&type=style&index=0&id=42fb0eb0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__